var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "mb-50 mb-md-1 border-info-2",
    attrs: {
      "body-class": "p-50"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-md-row justify-content-md-between mb-1"
  }, [_c('div', {
    staticClass: "bg-blue-gradient d-flex align-items-center mb-25 mb-md-0"
  }, [_c('div', {
    staticClass: "d-flex-center"
  }, [_c('b-alert', {
    staticClass: "p-75 p-md-1 mr-25 mr-md-75 mb-0",
    staticStyle: {
      "width": "fit-content"
    },
    attrs: {
      "show": "",
      "variant": "primary"
    }
  }, [_c('feather-icon', {
    staticClass: "text-body",
    attrs: {
      "icon": "StarIcon",
      "size": _vm.isMobileView ? '20' : '30'
    }
  })], 1)], 1), _c('div', [_c('div', {
    class: "text-airline fw-700 mb-0 mb-md-25 ".concat(_vm.isMobileView ? 'font-medium-4' : 'font-medium-3')
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.addonsBundle')) + " "), _vm.isMobileView ? _c('feather-icon', {
    staticClass: "text-info cursor-pointer",
    attrs: {
      "id": "header-tooltip-mobile-bundle",
      "icon": "InfoIcon",
      "size": "16"
    }
  }) : _vm._e()], 1), _vm.isMobileView ? _c('b-tooltip', {
    attrs: {
      "target": "header-tooltip-mobile-bundle",
      "triggers": "hover focus",
      "boundary": "window",
      "variant": "info"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.bundleDescription')) + " ")]) : _vm._e(), !_vm.isMobileView ? _c('span', {
    staticClass: "fw-600"
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.bundleDescription')) + " ")]) : _vm._e()], 1)])]), _c('IAmOverlay', {
    attrs: {
      "loading": _vm.loadingAncillary,
      "spinner-variant": 'info'
    }
  }, [_c('AppCollapse', {
    attrs: {
      "type": "border card"
    }
  }, _vm._l(_vm.tripDataLists, function (trip, indexTrip) {
    return _c('AppCollapseItem', {
      key: indexTrip,
      attrs: {
        "title": "",
        "isVisible": "",
        "class-header": "card-header bg-light-secondary",
        "class-body": "d-flex flex-wrap justify-content-center justify-content-md-start p-50",
        "card-class": "mb-50"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_c('span', {
            staticClass: "text-dark fw-700"
          }, [_vm._v(" " + _vm._s(_vm.$t('flight.itinerary')) + " " + _vm._s(indexTrip + 1) + ": " + _vm._s(_vm.getShortNameTripByMultiSegments(trip.segments)) + " ")])];
        },
        proxy: true
      }], null, true)
    }, [!_vm.loadingAncillary && _vm.isEmpty(trip.bundles) ? _c('div', {
      staticClass: "font-italic text-warning"
    }, [_vm._v(" " + _vm._s(_vm.$t('flight.noBundle')) + " ")]) : _vm._e(), _vm._l(trip.bundles, function (bundle) {
      var _bundle$fares, _bundle$fares$;
      return _c('b-card', {
        key: bundle.code,
        staticClass: "border-secondary mx-25 mx-md-50 mb-50 mb-md-25",
        style: _vm.isMobileView ? 'width: 100%' : 'min-width: 300px',
        attrs: {
          "body-class": "p-25 p-md-50",
          "footer-class": "p-0"
        },
        scopedSlots: _vm._u([{
          key: "footer",
          fn: function fn() {
            var _vm$passengerDataToAd;
            return [_c('div', {
              class: "d-flex-between cursor-pointer px-50 py-50 ".concat(_vm.isSelectedBundle(bundle) ? 'bg-light-success' : ''),
              on: {
                "click": function click($event) {
                  return _vm.selectBundleHandle(bundle, trip.segments[0].tripId);
                }
              }
            }, [_c('div', {}, [_vm.isSelectedBundle(bundle) ? _c('div', {
              staticClass: "fw-700 text-normal text-nowrap text-success"
            }, [_vm._v(" " + _vm._s(_vm.$t('flight.packageSelected')) + "! ")]) : _c('div', {
              staticClass: "fw-700 text-nowrap text-normal"
            }, [_vm._v(" " + _vm._s(_vm.$t('flight.selectPackagePaxTitle', {
              paxLen: (_vm$passengerDataToAd = _vm.passengerDataToAdd.filter(function (p) {
                return p.paxType !== 'INFANT';
              })) === null || _vm$passengerDataToAd === void 0 ? void 0 : _vm$passengerDataToAd.length
            })) + " ")])]), _c('div', [_vm.isSelectedBundle(bundle) ? _c('feather-icon', {
              staticClass: "text-danger border-danger rounded-circle",
              attrs: {
                "icon": "XIcon",
                "size": "24"
              }
            }) : _c('feather-icon', {
              staticClass: "text-primary border-warning rounded-circle",
              attrs: {
                "icon": "PlusIcon",
                "size": "24"
              }
            })], 1)])];
          },
          proxy: true
        }], null, true)
      }, [_c('div', {
        staticClass: "border-bottom pb-25 mb-50"
      }, [_c('div', {
        staticClass: "d-flex-between text-warning"
      }, [_c('span', {
        staticClass: "fw-700 font-medium-2"
      }, [_vm._v(_vm._s(bundle.key))]), _c('small', [_vm._v(_vm._s(bundle.code))])]), _c('div', {}, [_c('span', {
        staticClass: "fw-700 text-warning"
      }, [_vm._v(_vm._s(_vm.formatCurrency((bundle === null || bundle === void 0 ? void 0 : (_bundle$fares = bundle.fares) === null || _bundle$fares === void 0 ? void 0 : (_bundle$fares$ = _bundle$fares[0]) === null || _bundle$fares$ === void 0 ? void 0 : _bundle$fares$.total) || NaN)) + " VND")]), _vm._v(" /"), _c('span', {
        staticClass: "fw-600 text-small font-italic"
      }, [_vm._v("hành khách")])])]), _c('div', {
        staticClass: "font-weight-bolder"
      }, [_vm._v(" " + _vm._s(_vm.$t('flight.bundleIncludesPax')) + ": ")]), _vm._l(_vm.bundleBySsrCode(bundle.code).value.bundleSsrItems, function (bundleItem) {
        return _c('div', {
          key: bundleItem.code
        }, [_c('div', {
          staticClass: "ml-25"
        }, [_vm._v(" • " + _vm._s(bundleItem.name) + " ")])]);
      })], 2);
    })], 2);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }